import { useBlockProps, useInnerBlocksProps } from "@wordpress/block-editor";

/**
 * The wrapper emits core's `wp-block-buttons` alongside its own generated
 * `wp-block-brandy-buttons`, so `wp-includes/blocks/buttons/style.css` applies
 * verbatim — children get `margin: 0`, which is what lets the parent own
 * justification. `wp-block-brandy-buttons` is added automatically from the
 * block name and must not be repeated here.
 *
 * Justification itself is NOT styled anywhere in this block. Layout support
 * (`supports.layout` in block.json) makes core emit both the
 * `is-content-justification-*` class and the matching `.wp-container-…` rule
 * that positions the children. If justification ever looks wrong, fix
 * block.json — do not add CSS here.
 */
export default function Save() {
  const blockProps = useBlockProps.save({ className: "wp-block-buttons" });
  const innerBlocksProps = useInnerBlocksProps.save(blockProps);

  return <div {...innerBlocksProps} />;
}
